var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPeople02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.162,
    height: 106.85,
    viewBox: "0 0 38.162 106.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PeopleLeft",
    transform: "translate(-0.586 -0.236)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.532,43.85c-3.977,0-7.2-4.521-7.2-10.1s3.224-10.1,7.2-10.1,7.2,4.521,7.2,10.1S35.509,43.85,31.532,43.85Z",
    transform: "translate(-8.887 -8.765)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.16,31.382s-2.909-2.941-3.252-4S17.45,8.246,17.45,8.246,14.021-1.852,12.478.628,15.05,8.955,15.05,8.955s1.029,11.161,1.715,13.818,3.086,12.578,4.629,13.641L22.937,39.6l1.714.354,1.543-4.429-.171-1.772Z",
    transform: "translate(-4.321 0)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.054,125.153s-4.115,1.24-4.629.531-2.4,3.543-2.4,3.543v1.594l1.714.354s5.143-2.3,6-2.3S15.054,125.153,15.054,125.153Z",
    transform: "translate(-2.784 -46.754)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.955,126.809s2.4-2.126,1.886-2.48-2.572-2.835-3.6-1.417S-.417,132.124.783,133.9s2.057.708,2.057.708,3.189-4.429,4.423-4.429C7.264,130.175,5.584,128.227,6.955,126.809Z",
    transform: "translate(0 -45.753)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5,150.634s-.171,5.846,1.372,7.618-2.057,1.417-2.057,1.417l-3.772-2.657a13.524,13.524,0,0,0,.686-5.491Z",
    transform: "translate(-11.399 -56.291)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.222,158.528s.343-.354,1.2.709,2.572,2.3,3.6,1.24,1.029-.177,1.029-.177,2.229,3.721,4.115,4.252.514,2.3-1.2,1.594-10.116-3.72-10.116-3.72A7.9,7.9,0,0,1,30.222,158.528Z",
    transform: "translate(-10.579 -59.224)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.02,83.251l2.572,4.075s6.344,5.138,3.086,5.669-5.144-4.783-5.144-4.783l-2.229-2.835Z",
    transform: "translate(-17.86 -31.071)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.281,82.119s-2.915,4.429-4.286,4.783-.857-3.366-.857-3.366Z",
    transform: "translate(-16.265 -30.647)",
    fill: "#004ca6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.633,81.553l-.514,9.212S42,104.406,39.09,107.595c0,0-1.714,4.783-1.714,6.554s-1.2,12.4-1.2,12.4H31.2s-1.029-14.7,1.715-19.31V82.084Z",
    transform: "translate(-11.389 -30.435)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.719,110.729c-.024,3.249-.4,6.443-1.627,7.786,0,0-1.715,4.783-1.715,6.554s-1.2,12.4-1.2,12.4H31.205s-1.029-14.7,1.714-19.31v-6.578",
    transform: "translate(-11.39 -41.355)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.32,84.946l5.143,14s3.086,12.046-.686,13.287-13.545.885-15.088,2.126-2.4-3.72-1.886-4.252,8.744-3.366,12.173-3.366c0,0-9.087-12.755-6.858-15.59S28.434,84.769,30.32,84.946Z",
    transform: "translate(-6.388 -31.703)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.936,41.916s-.171,4.783.686,4.96a12.883,12.883,0,0,1,2.057.709v2.657l-1.372.886L34.878,49l-1.372-1.24-1.372-1.24s.857-2.48,0-4.075Z",
    transform: "translate(-11.808 -15.6)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.936,41.916s-.171,4.783.686,4.96a12.883,12.883,0,0,1,2.057.709v2.657l-1.372.886L34.878,49l-1.372-1.24-1.372-1.24s.857-2.48,0-4.075Z",
    transform: "translate(-11.808 -15.6)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.06,51.811s-2.915-2.835-3.6-2.657S28.8,48,28.8,48a23.518,23.518,0,0,1,.772,4.163,3.452,3.452,0,0,1-.327,2.12,5.66,5.66,0,0,0-.592,1.219c-.284.857-.809,1.892-1.481.735,0,0,.343,1.949.686,7.618a20.912,20.912,0,0,1-1.543,9.566s-1.543,4.252-.857,5.138c0,0,5.315-3.543,4.972-5.138,0,0,12.344-1.772,12.344-4.075a4.152,4.152,0,0,0-.45-1.9,4,4,0,0,0-1.264-1.462,15.308,15.308,0,0,0-.686-3.189s1.886-4.075.171-7.441c0,0,1.543-4.606-.514-5.669a7.937,7.937,0,0,0-4.629-.531s2.4,1.594.857,2.48Z",
    transform: "translate(-9.244 -17.878)",
    fill: "#0d71e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.137,40.014a4.431,4.431,0,1,1,4.286-4.429A4.359,4.359,0,0,1,33.137,40.014Z",
    transform: "translate(-10.579 -11.573)",
    fill: "#a0616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.328,35.02c-2.6,0-4.715-1.15-4.715-2.569s2.111-2.569,4.715-2.569,4.715,1.15,4.715,2.569S34.932,35.02,32.328,35.02Z",
    transform: "translate(-10.116 -11.096)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.241,27.055a1.418,1.418,0,1,1,1.372-1.417A1.4,1.4,0,0,1,43.241,27.055Z",
    transform: "translate(-15.452 -8.977)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8,27.055a1.418,1.418,0,1,1,1.372-1.417A1.4,1.4,0,0,1,26.8,27.055Z",
    transform: "translate(-9.298 -8.977)",
    fill: "#2f2e41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople02);
export default __webpack_public_path__ + "static/media/people02.c13d4bc681f26c4036355c9ab465a984.svg";
export { ForwardRef as ReactComponent };